import {FullscreenGalleryPortal} from "./fullscreen_gallery"
import PremiumPopover from "components/premium_popover"
import React, {useState} from "react"
import modal from "modal"
import FaIcon from "components/fa_icon"

const ZoomIcon = ({
  allow_fullscreen,
  current_image,
  images,
  source
}) => {
  const [show_popover, set_show_popover] = useState(false)
  const [show_fullscreen_layer, set_show_fullscreen_layer] = useState(false)
  const [zoom_icon_element, set_zoom_icon_element] = useState(null)
  const current_index = images.findIndex((image) => image === current_image)
  const on_click = () => {
    if (document.getElementById("gallery_reg_wall_modal")) {
      modal("#gallery_reg_wall_modal")
      return false
    } else if (allow_fullscreen) {
      set_show_fullscreen_layer(true)
    } else {
      set_show_popover(!show_popover)
    }
  }

  return (
    <React.Fragment>
      <div
        className="zoom-icon"
        ref={set_zoom_icon_element}
        onClick={on_click}
      >
        <FaIcon name={"fa-search-plus"}/>
      </div>
      {!allow_fullscreen &&
        <PremiumPopover
          target={zoom_icon_element}
          placement="left"
          // doesn't allow the popover to flip right
          modifiers={[{
            name: "flip",
            options: {fallbackPlacements: ["left", "bottom", "top"]}
          }]}
          element={`${source} zoom icon`}
          on_close={() => set_show_popover(false)}
          is_open={show_popover}
        />}
      {show_fullscreen_layer &&
        <FullscreenGalleryPortal
          images={images}
          current_index={current_index}
          on_close={() => set_show_fullscreen_layer(false)}
        />}
    </React.Fragment>
  )
}

export default ZoomIcon
